import React from "react";
import WarningIcon from "@mui/icons-material/ErrorOutline";
import SettingsIcon from "@mui/icons-material/Settings";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { TicketProcessingStateEnum } from "@/api/hausify";

/**
 *
 * @param {*} status
 */
export const getProcessIconByProcessingState = (status) => {
  const baseProps = {
    style: {
      fontSize: "small",
    },
  };
  switch (status) {
    case TicketProcessingStateEnum.New:
      return <WarningIcon {...baseProps} style={{ color: "#FF1B1C" }} />;
    case TicketProcessingStateEnum.InProgress:
      return <SettingsIcon {...baseProps} style={{ color: "#FCA921" }} />;
    case TicketProcessingStateEnum.WorkDone:
    case TicketProcessingStateEnum.Solved:
      return <CheckCircleIcon {...baseProps} style={{ color: "#7FB800" }} />;
    default:
  }
};
